<template>
  <div>
    <!-- banner -->
    <div class="about fm-justifycenter">
      <div class="about-div">
        <div class="about-maintitle">关于我们</div>
        <div class="about-content">
          河北智数软件有限公司，坐落于河北邯郸，目前专注于数仓建设、数据治理、信息化建设和技术研发
          领域，在网站、app、小程序、智能机器人等开发基础上提供更多集成和个性化定制的技术应用。公司现拥有自主研发的产品：ERP、智数云打印、智慧后勤，并已应用于上百家商户，技术人员和产品得到广大客户的认可。
        </div>
      </div>
      <el-image
        class="about-leftimg"
        src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/about-bannerleft.png"
      ></el-image>
      <el-image
        class="about-rightimg"
        src="https://fmerp.oss-cn-hangzhou.aliyuncs.com/website/about-bannerright.png"
      ></el-image>
    </div>
    <div class="fm-aligncenter" style="margin-top: 40px; margin-bottom: 30px">
      <div class="maincontent-title">联系我们</div>
      <el-card style="width: 1200px; padding: 10px">
        <div class="maincontent-content" style="text-align: center">
          欢迎通过电子邮箱联系我们，24小时全天有效
        </div>
        <div
          class="maincontent-content fm-margin-bottom-30"
          style="text-align: center"
        >
          我们会对您的留言或问题进行备案，并通过电子邮箱等联系方式通知您
        </div>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-card style="width: 100%; text-align: center">
              <el-descriptions
                title="河北智数软件有限公司"
                :column="1"
                size="medium"
                :colon="false"
              >
                <el-descriptions-item label="地址"
                  >河北省邯郸市丛台区恒隆广场20层 21层</el-descriptions-item
                >
                <el-descriptions-item label="E-MAIL"
                  >contact@intelure.com</el-descriptions-item
                >
              </el-descriptions>
              <el-image
                style="height: 125px; width: 125px; margin-top: 20px"
                :src="require('@/assets/images/qywxqrcode.png')"
                fit="contain"
              ></el-image>
            </el-card>
          </el-col>
          <el-col :span="18">
            <!-- 地图容器 -->
            <div id="mapcontainer"></div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Fmerpv2WebLoginAbout",

  data() {
    return {
      map: null,
    };
  },

  mounted() {},

  methods: {
    flushMap() {
      setTimeout(() => {
        if (this.map) {
          return;
        }
        let zoom = 15;
        let lnglat = new T.LngLat(114.47938, 36.6167);

        this.map = new T.Map("mapcontainer", {
          center: lnglat,
          zoom: zoom,
        });
        this.map.centerAndZoom(lnglat, zoom);

        // this.map.addEventListener("click", (e) => {
        //   console.log(e.lnglat.getLng() + "," + e.lnglat.getLat());
        // });

        //创建标注对象
        let marker = new T.Marker(lnglat);
        //向地图上添加标注
        this.map.addOverLay(marker);

        // 文字标注
        let latlng = lnglat;
        let label = new T.Label({
          text: "<div><div style='text-align: left;font-weight: bold;font-size:1.2em;'>河北智数软件有限公司</div><div>河北省邯郸市丛台区恒隆广场20层、21层</div></div>",
          position: latlng,
          offset: new T.Point(5, -35),
        });
        //创建地图文本对象
        this.map.addOverLay(label);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.maincontent {
  height: 36.875vw;
  min-height: 479.375px;
  position: relative;

  &-div {
    position: relative;
    left: 100px;
    width: 550px;
    z-index: 1;
    margin-top: 70px;
  }

  &-maintitle {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 10px;
    text-align: justify;
  }

  &-img {
    width: 100vw;
    min-width: 1000px;
    height: 36.875vw;
    min-height: 479.375px;
    position: absolute;
    right: 0;
    top: 0;
  }

  &-bg {
    background-color: #fff9f6;
  }
}

.content {
  position: relative;
  font-size: 16px;
  width: 1100px;

  &-divl {
    position: relative;
    width: 600px;
    z-index: 1;
    left: 10px;
    font-size: 18px;
    > * {
      padding-bottom: 8px;
    }
  }

  &-divr {
    position: relative;
    width: 650px;
    z-index: 1;
    left: 480px;
    font-size: 18px;
    margin-bottom: 20px;

    > * {
      padding-bottom: 8px;
    }
  }

  &-title {
    font-size: 42px;
    font-weight: bold;
  }

  &-titledesc {
    width: 53px;
    height: 38px;
    margin: 75px 30px;
  }

  &-subtitle {
    font-size: 20px;
    line-height: 40px;
    font-weight: bold;
    color: #195bda;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 40px;
    margin-bottom: 20px;
  }

  &-imgr {
    width: 650px;
    height: 441px;
  }
  &-imgl {
    width: 650px;
    height: 441px;
  }
}

.about {
  height: 36.875vw;
  min-height: 479.375px;
  position: relative;

  &-div {
    position: relative;
    left: 100px;
    width: 450px;
    z-index: 3;
    margin-top: 50px;
  }

  &-maintitle {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 30px;
  }

  &-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  &-content {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 10px;
    text-align: justify;
  }

  &-leftimg {
    width: 58.59vw;
    min-width: 750px;
    height: 36.97vw;
    min-height: 473.33px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }

  &-rightimg {
    width: 100vw;
    min-width: 1280px;
    height: 36.97vw;
    min-height: 473.33px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }

  &-bg {
    background-color: #fff9f6;
  }
}

#mapcontainer {
  height: 380px;
  width: 100%;
  border-radius: 15px;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginAbout.vue